import { FormattedMessage } from 'react-intl';
import { BREAKPOINT_MD_SIZE, BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import Button from '@alltrails/denali/components/Button';
import Picture from '@alltrails/core/components/Picture';
import LogoMorph from './LogoMorph';
import upgradeImg from './Upgrade.avif';
import upgradeMobileImg from './Upgrade-M.avif';
import styles from './styles.module.scss';

const MEDIA_QUERY_SMALL_DOWN = `(max-width: ${BREAKPOINT_SM_SIZE}px)`;

// Designs: https://www.figma.com/design/SLeQY3u3PIQLGina96uVji/2025-Web-Pages?node-id=6982-1924&m=dev

type Props = {
  windowWidth: number;
};

const UpgradeYourAdventures = ({ windowWidth }: Props) => {
  const ctaButtonSize = windowWidth <= BREAKPOINT_MD_SIZE ? 'sm' : 'md';

  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <div className={styles.contentAndImageContainer}>
          <Picture
            alt=""
            className={styles.image}
            sources={[
              { src: upgradeMobileImg, media: MEDIA_QUERY_SMALL_DOWN, sizes: '100vw' },
              { src: upgradeImg, sizes: '100vw' }
            ]}
          />

          <div className={styles.imageOverlay}>
            <div className={styles.content}>
              <div className={styles.logoAnimation}>
                <LogoMorph />
              </div>
              <h2 className={styles.header}>
                <FormattedMessage defaultMessage="Upgrade your adventures" />
              </h2>
              <div className={styles.subText}>
                <FormattedMessage defaultMessage="Whether you want to explore offline or create your own route, choose the membership that helps you make the most of every minute outdoors." />
              </div>
              <Button
                allowWrap
                text={<FormattedMessage defaultMessage="Compare plans" />}
                linkInfo={{ href: '/plus' }}
                testId="upgrade-your-adventures-button"
                variant="accent"
                size={ctaButtonSize}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeYourAdventures;
